// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2EoXf","fileBtn":"File_fileBtn__QnNmE","closeBtn":"File_closeBtn__30ga_","fileSelected":"File_fileSelected__2_JlI","disabled":"File_disabled__3UIPR"};